import React from 'react'
import { Shoe } from '../../../assets/images'

const StepathonUtilization = ({classes = '', label = '', color = '', title = '', icon = '', imgClasses = 'h-16 w-16', btnText = '', titleClasses='text-gray-800', labelClasses = 'text-base leading-4 font-semibold text-gray-900 mt-4',  handler = () => {}}) => {
  return (
    <div className={'text-center py-12 rounded-md h-full' + classes} style={{backgroundColor: color}}>
      <img className={`${imgClasses} inline-block`} src={icon || Shoe}/>
      <label className={`block ${labelClasses}`}>{label}</label>
       {title && <p className={`${titleClasses} text-base leading-5 mt-3 mb-0`}>{title}</p>}
      {btnText && 
        <button className=' rounded-md leading-5 mt-3 px-6 py-3 bg-blue-600  text-base font-semibold text-white focus:outline-none' onClick={handler}>
          {btnText}
        </button>
      }
    </div>
  )
}

export default StepathonUtilization